import { Observable, throwError } from 'rxjs';

import { ErrorHandlerService } from '../shared/error-handler.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StaticPageInterface } from '@app/interfaces/static-page.interface';
import { WordpressPaging } from '@app/enums/_index';
import { catchError } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { getCacheBustedParams } from '@app/utilities/cacheBustedHttpParams.utilities';

@Injectable({
  providedIn: 'root',
})
export class CertificationsTrainingService extends ErrorHandlerService {
  private certificationContentURL = `${environment.cms.url}/wp-json/wp/v2/certification`;

  constructor(private http: HttpClient) {
    super();
  }

  /**
   * Returns all the information related to certification
   * @returns Certification content Observable
   */
  getCertificationContent(): Observable<StaticPageInterface[]> {
    const certificationContentParams = getCacheBustedParams()
      .append(WordpressPaging.ORDER_BY_KEY, WordpressPaging.ORDER_BY_VALUE)
      .append(WordpressPaging.ORDER_KEY, WordpressPaging.ORDER_VALUE);

    return this.http
      .get(`${this.certificationContentURL}`, { params: certificationContentParams })
      .pipe(
        catchError((err) => {
          console.log(`Service error has occurred`, err);
          return throwError(() => new Error(err));
        }),
        catchError(this.handleError<StaticPageInterface[]>('getCertificationContent', []))
      );
  }
}
